<template style="width:100%">
  <header>
    <div class="content">
      <div class="left">
        <hr>
        <h1 class="poppins-thin"><span>LR PRO</span><br>Marketing</h1>
        <h3 class="montserrat">Digitalizando tu negocio</h3>
        <p class="nunito"></p>
      </div>
      <div class="right">
        <div class="content-img">
          <img src="../assets/utility/logo/Logo LR Pro Marketing sin slogan.png" title="Logo Lr Pro Marketing" alt="Logo Lr Pro Marketing sin slogan y circular">
          <img src="../assets/utility/logo/Logo LR Pro Marketing sin slogan.png" title="Logo Lr Pro Marketing" alt="Logo Lr Pro Marketing sin slogan y circular">
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'HeaderComponent'
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
* {
  // border:1px solid;
}
body.dark-theme header {

  .content {
    .left {
      hr {
        background-color: rgb(59, 59, 59);
      }

      h1 {
        color: white;
      }

      h3 {
        color: rgb(234, 234, 234);
      }

      p {
        color: #ccc;
      }
    }

    .right {
      img:nth-child(1) {
        display: none;
      }

      img:nth-child(2) {
        display: block;
      }
    }
  }
}

header {
  width: 100%;

  @media (max-width: $breakpoint-xs) {
    width: 100%;
  }

  .content {
    padding: 50px 20px;
    max-width: 1280px;
    margin: 0 auto;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    gap:20px 0;
    @media (max-width: $breakpoint-lg) {
      width:90%;
      flex-wrap: wrap;
    }
    @media (max-width: $breakpoint-md) {
      flex-direction: column-reverse;
      width:95%;
      padding:80px 20px;
    }
    @media (max-width: $breakpoint-sm) {
      width:100%;
    }
    
    .left {
      width: 50%;
      @media (max-width: $breakpoint-md) {
        width: 100%;
        text-align: center;
      }
      hr {
        border-radius: 10px;
        height: 5px;
        width: 50px;
        background-color: rgb(23, 3, 49);
        border: none;
        @media (max-width: $breakpoint-md) {
          margin:0 auto;
        }
      }

      h1 {
        font-size: 4rem;
        text-transform: uppercase;

        @media (max-width: $breakpoint-lg) {
          font-size: 3rem;
        }
        @media (max-width: $breakpoint-md) {
          font-size: 2rem;
        }
        @media (max-width: $breakpoint-sm) {
          font-size: 1.8rem;
        }
        @media (max-width: $breakpoint-xs) {
          font-size: 1.4rem;
        }

        span {
          color: #cf7606;
        }
      }

      h3 {
        margin: 10px 0;
        font-size: 23px;
        @media (max-width: $breakpoint-lg) {
          font-size: 22px;
          margin:0;
        }
        @media (max-width: $breakpoint-md) {
          font-size: 20px;
        }
        @media (max-width: $breakpoint-sm) {
          font-size: 18px;
        }
        @media (max-width: $breakpoint-xs) {
          font-size: 16px;
        }
      }

      p {
        width: 95%;
        font-size: 18px;
      }
    }

    .right {
      flex: 1;

      .content-img {
        width:100%;
        margin:0 auto;
        display: flex;
        justify-content: center;
        img {
          max-width: 400px;
          width:100%;
          @media (max-width: $breakpoint-xs) {
            width: 100%;
          }
        }

        img:nth-child(1) {
          display: inline-flex;
        }

        img:nth-child(2) {
          display: none;
        }
      }

    }


  }
}



// @media (min-width: $breakpoint-sm) {
//   background-color: lightpink;
// }

// @media (min-width: $breakpoint-md) {
//   background-color: lightblue;
// }

// @media (min-width: $breakpoint-lg) {
//   background-color: lightgreen;
// }

// @media (min-width: $breakpoint-xl) {
//   background-color: lightgoldenrodyellow;
// }</style>